import React, { ComponentPropsWithoutRef } from 'react';
import { StyledDragHandle } from './DragHandle.styles';
import { Icon } from '../Icon/Icon';
import { MarginProps } from '../../../theme/styledProps';

interface DragHandleProps extends ComponentPropsWithoutRef<'div'>, MarginProps {}

export const DragHandle: React.FC<DragHandleProps> = props => {
  return (
    <StyledDragHandle {...props}>
      <Icon className="fas fa-grip-vertical" />
    </StyledDragHandle>
  );
};
